import {makeAutoObservable} from "mobx";
import {buildFormula} from "../utils";
import {grid} from "./GridStore";
import {Linn} from "./LinnStore";
//
// const COLORS_MAPPING = [
//     8, // white
//     11, // pink
//     1, // red
//     9, // orange
//     10, // lime
//     3, // green
//     4, // cyan
//     5, // blue
//     6 // magenta
// ];

/*
const COLORS_MAPPING = [
    8, // white
    // 11, // pink
    1, // red
    // 9, // orange
    // 10, // lime
    3, // green
    // 4, // cyan
    5, // blue
    // 6 // magenta
]
*/

// export const COLORS_MAPPING = [
//     8, // white
//     11, // pink
//     1, // red
//     // 9, // orange
//     // 10, // lime
//     // 3, // green
//     // 4, // cyan
//     // 5, // blue
//     // 6 // magenta
// ]


// export interface Formula {
//     (x: number, y: number, t: number, i: number): number;
// }

class AnimationStore {

    autoStart = false;
    running = false;

    requestRef : any = null;
    previousTimeRef : any = null;

    colorsList = '8 11 1';
    colors = [
        8, 11, 1
    ];

    refreshRate: number;
    tickPeriod: number;         // [ms]
    timestamp: number;

    speed: number;

    instructions: string;
    formula: Function;

    minV: number;
    maxV: number;

    constructor() {
        // console.log("AnimationStore.constructor");

        makeAutoObservable(this);

        // this.minV = 1000;
        // this.maxV = -1000;
        this.minV = Infinity;
        this.maxV = -Infinity;

        let h = window.location.hash;
        // console.log("h:", h);

        // let instr, options;
        // if (h && h.length > 1) {
        //     [instr, options] = decodeURIComponent(h.substring(1)).split('@');
        // } else {
        //     [instr, options] = 'sin(atan2(y,x)*5 + t*s), 1'.split(',');
        // }
        // this.instructions = instr.trim();
        // if (options) {
        //     let n = parseFloat(options.trim());
        //     if (!isNaN(n)) this.speed = n;
        // }

        this.instructions = '';

        if (h && h.length > 1) {
            this.newInstructions(decodeURIComponent(h.substring(1)));
        } else {
            this.newInstructions('sin(atan2(y,x)*5 + t*s), 1');
        }

        // console.log("AnimationStore.constructor", h, this.instructions);

        this.formula = buildFormula(this.instructions);
        this.speed = 1;
        this.refreshRate = 15;
        this.timestamp = -1;
        this.tickPeriod = 1000 / this.refreshRate;  // [ms]
        if (this.autoStart) this.requestRef = requestAnimationFrame(this.animate);
    }

    addColor(color: number) {
        //if (!this.colors.includes(color)) this.colors.push(color);
        this.updateColorsList(`${this.colorsList} ${color}`);
    }
    //
    // removeColor(color: number) {
    //     this.colors = this.colors.filter(c => c !== color);
    // }

    updateColorsList(s: string) {
        this.colorsList = s;
        if (!s || !s.trim()) {
            this.colors = [];
            return;
        }
        // console.log(s);
        const c = s.replace(/,/g, ' ').replace(/\s\s+/g, ' ').trim().split(' ');
        this.colors = c.map(e => parseInt(e.trim(), 10));
    }

    newInstructions(s: string) {
        if (!s || !s.trim()) return;
        let [instr, options] = s.split('@');    // ',' and ';' may be used in the formula itself
        // console.log("newInstructions", s, instr, options);
        this.instructions = instr;
        if (options) {
            const opts = options.split(' ');
            for (const opt of opts) {
                let [o, v] = opt.trim().split('=');
                // console.log(o, '=', v);
                if (o && v) {
                    switch (o.trim().toLowerCase()) {
                        // case 'r':   // refresh rate
                        //     console.log("speed option", v);
                        //     let n = parseFloat(v.trim());
                        //     if (!isNaN(n)) {
                        //         this.speed = n;
                        //     }
                        //     break;
                        case 's':   // speed
                            let n = parseFloat(v.trim());
                            if (!isNaN(n)) {
                                this.speed = n;
                            }
                            break;
                        case 'c':   // colors
                            this.colorsList = v.replace(/,/g, ' ');
                            this.updateColorsList(this.colorsList);
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    }

    updateFormula(s: string) {
        this.newInstructions(s);
        this.formula = buildFormula(this.instructions);
        this.minV = Infinity;
        this.maxV = -Infinity;
        // console.log("updateFormula", this.instructions);
        window.location.hash = '#' + encodeURIComponent(`${this.instructions} @ s=${this.speed} c=${this.colors.join(',')}`);
    }

    setRefreshRate(f: number): void {
        this.refreshRate = f;
        this.tickPeriod = 1000 / this.refreshRate;
    }

    setSpeed(s: number): void {
        this.speed = s;
    }

    /**
     * Must returns a value between -1 and 1
     * @param x col
     * @param y row
     * @param t time in seconds, from 0
     * @param i cell index from 0 to (cols*rows)-1
     * @param s speed
     */
/*
    f(x: number, y: number, t: number, i: number, s: number, r: number) {

        // A cell has always the same x, y and i

        // return ((t*this.speed + x) % grid.columns) / grid.columns;   // OK
        // return -.4 / (Math.hypot(x-t%10,y-t%8)-t%2*9);  // OK explosions

        return Math.sin(Math.atan2(x, y) * 5 + t * s);

        // return Math.sin(y/4 + t * this.speed);

        // return i / (grid.columns * grid.rows);
        // return x / grid.columns;
        // console.log(t, (x - t) % grid.columns / grid.columns);
        // return (x + (t % grid.columns)) / grid.columns;
        // return Math.abs((x - t) % grid.columns) / grid.columns;
        // return t % 2;
        // const v = y / 7 * 2 - 1;
        // return Math.sin(t*this.speed-Math.sqrt(((x-1)-7.5)**2+(y-6)**2));

    }
*/

    tick(time: number) {

        // if (!this.running) return;
        if (this.running) {
            if (this.timestamp < 0) this.timestamp = time;
        // } else {
        //     console.log("not running", this.timestamp);
        }

        // if (this.timestamp < 0) this.timestamp = time;
        const elapsed = time - this.timestamp;

        // if enough time has elapsed, compute the next value
        if (elapsed > this.tickPeriod) {

            if (this.running) this.timestamp = time - (elapsed % this.tickPeriod);
            const t = this.timestamp / 1000;

            // console.log(t);

            // const r = Math.random();

            let i = 0;
            let r = 0;

            for (let x = 0; x < grid.columns; x++) {   // column 0 is the control buttons. For the Linn-128 we therefore have 1+16 columns, for the Linn-200, we have 1+25 columns.
                for (let y = 0; y < grid.rows; y++) {

                    // t = time in seconds
                    // i = index (0..255)
                    // x : col 0..15
                    // y : row 0..15

                    if (this.running) r = Math.random();

                    // const i = y * 16 + x;

                    // const v = x / 15 * 2 - 1;
                    // const v = y / 7 * 2 - 1;
                    // const v = Math.sin(t-Math.sqrt((x-7.5)**2+(y-6)**2));
                    // const v = Math.sin(3 * Math.atan2(y - 7.5,x - 7.5) + t)
                    // const v = -.4 / (Math.hypot(x-t%10,y-t%8)-t%2*9);
                    // const v = x%4 && y%4;   // grid
                    // const v = (y-4*t|0) * (x-2-t|0);   // moving cross
                    // const v = Math.random() * 2 - 1;
                    // const v = Math.cos(t + i + x * y);

                    // const v = this.f(x, y, t, i);
                    const v = this.formula(x, y, t * this.speed, i, this.speed, r);

                    i++;

                    this.minV = Math.min(this.minV, v);
                    this.maxV = Math.max(this.maxV, v);

                    if (typeof v === 'number') {
                        grid.cells[x][y].value = v.toFixed(1);

                        // grid.cells[x][y].color = Math.round((v + 1.0) / 2 * 11);
                        // const color_index = Math.floor(v * COLORS_MAPPING.length);

                        const color_index = Math.round((v+1) / 2 * (this.colors.length - 1));

                        const c = (color_index < 0 || color_index >= this.colors.length) ? 0 : this.colors[color_index];
                        // console.log('color', color_index, c, v);
                        grid.cells[x][y].color = c;
                        // grid.cells[x][y].color = color_index;

                        if (this.running) Linn.turnOnCell(x+1, y, c);

                    } else {

                        grid.cells[x][y].value = null;
                        grid.cells[x][y].color = 0;

                        if (this.running) Linn.turnOffCell(x+1, y);
                    }

                    // grid.cells[x][y].value = v;

                    // https://github.com/rogerlinndesign/linnstrument-firmware/blob/master/midi.txt
                    // white: 255,255,255
                    // red: white: 255,34,68
                    // 0   as set in Note Lights settings

                    // 1   Red
                    // 9   Orange
                    // 2   Yellow
                    // 3   Green
                    // 4   Cyan
                    // 5   Blue
                    // 6   Magenta

                    // 7   Off
                    // 8   White
                    // 10  Lime
                    // 11  Pink

                    // const c = v >= 0 ?

                }
            }

            // this.x = (this.x + elapsed / this.tickPeriod) % 360;
            // if (this.regenWave) {
            //     if (this.x < this.prevX) {
            //         this.regenWave();
            //         this.regenCounter++;
            //     }
            // }
            // this.prevX = this.x;
            // this.updateOutput();

        }
    }

    animate = (time: number) => {

        // console.log("animate", this.running);

        if (this.previousTimeRef !== undefined) {
            this.tick(time);
            // this.modulators.forEach(
            //     m => {
            //         m.tick(time);
            //     }
            // );
        }
        this.previousTimeRef = time;
        // if (this.running) this.requestRef = requestAnimationFrame(this.animate);
        this.requestRef = requestAnimationFrame(this.animate);
    }

    play = () => {
        // console.log("animation.play", this.running);
        this.running = true;    // this is used with the SPACE keyboard shortcut
        this.requestRef = requestAnimationFrame(this.animate);
        // console.log("animation.play:", this.running);
    }

    stop = () => {
        // console.log("animation.stop");
        this.running = false;
        // console.log("animation.stop:", this.running);
    }

}

export const animation = new AnimationStore();
